module.exports = __webpack_public_path__ + "img/recipe-show.e8cbdae5.gif";